import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-50 font-sans">
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <FAQSection />
        <MediaSection />
        <IndexSection />
        <TopicsSection />
        <AppSection />
        <AboutSection />
        <FeaturesSection />
        <CarouselSection />
        <RankingSection />
        <ContactSection />
        <UpdatesSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}